var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZendesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.574 13.158c0 6.517-5.283 11.8-11.8 11.8-6.518 0-11.8-5.283-11.8-11.8h23.6zm3.887 38.722c0-6.518 5.284-11.801 11.8-11.801 6.518 0 11.8 5.283 11.8 11.8h-23.6zm0-10.228V13.158h23.603zm-3.887-18.266V51.88h-23.6z",
    fill: "#03363D"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjR2NjRIMHoiLz48cGF0aCBkPSJNMzAuNTc0IDEzLjE1OGMwIDYuNTE3LTUuMjgzIDExLjgtMTEuOCAxMS44LTYuNTE4IDAtMTEuOC01LjI4My0xMS44LTExLjhoMjMuNnptMy44ODcgMzguNzIyYzAtNi41MTggNS4yODQtMTEuODAxIDExLjgtMTEuODAxIDYuNTE4IDAgMTEuOCA1LjI4MyAxMS44IDExLjhoLTIzLjZ6bTAtMTAuMjI4VjEzLjE1OGgyMy42MDN6bS0zLjg4Ny0xOC4yNjZWNTEuODhoLTIzLjZ6IiBmaWxsPSIjMDMzNjNEIi8+PC9nPjwvc3ZnPg==";
export { SvgZendesk as ReactComponent };